import { Component, OnInit, Inject  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-tarjetacompleta',
  templateUrl: './tarjetacompleta.component.html',
  styleUrls: ['./tarjetacompleta.component.css']
})
export class TarjetacompletaComponent implements OnInit {

  resumen = '';
  desco = '';
  constructor(public dialogRef: MatDialogRef<TarjetacompletaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { titulo: '' ,
                                            resumen: '' ,
                                            desconexion: '',
                                            dimID: ''}) { }

  ngOnInit() {
    // ('En tarjeta completa');
    // console.log(this.data.dimID);
  }

  close() {
    this.dialogRef.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/tarjetacompleta/tarjetacompleta.component.ts